import Stamps from './stamps';
import StampsWhiteLabel from './stampsWhiteLabel';
import BillingEngineWallet from './billingEngineWallet';

const walletList = [Stamps, StampsWhiteLabel, BillingEngineWallet];

export default walletList;
